<template>
  <div class="d-inline-flex flex-row datetimepicker">
    <div class="mr-3">
      <v-menu
        ref="datePickerMenu"
        v-model="datePickerMenu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :id="dateId"
            v-model="dateInput"
            prepend-icon="mdi-calendar"
            :placeholder="$t('date')"
            @blur="date = parseDate(dateInput)"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="date"
          no-title
          scrollable
          @click:date="$refs.datePickerMenu.save(date)"
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="timepicker">
      <v-menu
        ref="timePickerMenu"
        v-model="timePickerMenu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :id="timeId"
            v-model="timeInput"
            :placeholder="$t('time')"
            @blur="time = parseTime(timeInput)"
            v-on="on"
          ></v-text-field>
        </template>
        <v-time-picker
          v-model="time"
          full-width
          scrollable
          format="24hr"
          use-seconds
          @click:second="$refs.timePickerMenu.save(time)"
        ></v-time-picker>
      </v-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DateTimePicker',

  props: {
    value: {
      type: String,
      default: undefined
    },
    dateId: {
      type: String,
      default: undefined
    },
    timeId: {
      type: String,
      default: undefined
    }
  },

  data() {
    return {
      date: null,
      dateInput: null,
      datePickerMenu: false,
      time: null,
      timeInput: null,
      timePickerMenu: false
    }
  },

  watch: {
    value(val) {
      if (val == null) {
        this.date = null
        this.time = null
      }
    },

    date(val) {
      this.dateInput = this.date
      this.parseDate(this.date)
    },

    dateInput(val) {
      this.date = this.dateInput
    },

    time(val) {
      this.timeInput = this.time
      this.parseTime(this.time)
    },

    timeInput(val) {
      this.time = this.timeInput
    }
  },

  methods: {
    parseDate(date) {
      if (!date) return null

      if (this.time == null) {
        this.time = '00:00:00'
      }

      this.releaseDateAndTime(date, this.time)
      return date
    },

    parseTime(time) {
      if (!time) return null

      if (this.date == null) {
        this.date = new Date().toISOString().substr(0, 10)
      }

      this.releaseDateAndTime(this.date, time)
      return time
    },

    releaseDateAndTime(date, time) {
      this.$emit('input', new Date(date + ' ' + time).toISOString())
    }
  }
}
</script>

<style>
.datetimepicker {
  width: 160pt;
}

.timepicker {
  width: 75pt;
}
</style>
